import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import ModalOptions from './modal-options.entity';

@Component
export default class ModalConfirmMixin extends Vue {
  @Prop({
    required: true,
  })
  private value!: boolean;

  @Prop({
    required: false,
    default: 'Deseja realmente prosseguir? Ao clicar no botão Sim, as alterações serão imediatamente realizadas.',
  })
  private question!: string;

  @Emit('ok')
  private ok(): void {}

  @Emit('cancel')
  private cancel(): void {}

  private get options(): ModalOptions {
    return {
      title: 'Importante',
      description: this.question,
      showOk: true,
      labelOk: 'Sim',
      showCancel: true,
      labelCancel: 'Não',
      width: 500,
    }
  }
}
